// Display-only formatting; persisted remarks and ledger amounts remain intact.
export function coinRemark(record, locale = 'zh-tw') {
  const en = locale === 'en', cn = locale === 'zh-cn'
  const words = en ? {
    remark: 'Remark', details: 'Details', title: 'Record details', operation: 'Operation ID', original: 'Original remark',
    DOOR_HOLD: 'Door hold', DOOR_OPEN: 'Door confirmed', DOOR_RELEASE: 'Hold released',
  } : cn ? {
    remark: '备注', details: '详情', title: '记录详情', operation: '操作编号', original: '原始备注',
    DOOR_HOLD: '开门预留', DOOR_OPEN: '开门成功', DOOR_RELEASE: '预留退回',
  } : {
    remark: '備註', details: '詳情', title: '記錄詳情', operation: '操作編號', original: '原始備註',
    DOOR_HOLD: '開門預留', DOOR_OPEN: '開門成功', DOOR_RELEASE: '預留退回',
  }
  const original = String(record.remark || '')
  const isDoor = ['DOOR_HOLD', 'DOOR_OPEN', 'DOOR_RELEASE'].includes(record.type)
  const id = isDoor && original.match(/\b[a-f0-9]{32}\b/i)
  const charged = original.match(/Door charged ([1-9][0-9]*) coin\(s\);/)
  const n = Math.abs(record.amount)
  let summary = original
  if (record.type === 'DOOR_HOLD') summary = en ? `${n} coin(s) reserved; awaiting result` : cn ? `暂扣 ${n} 枚，等待开门结果` : `暫扣 ${n} 枚，等待開門結果`
  if (record.type === 'DOOR_RELEASE') summary = en ? 'Reserved coins returned' : cn ? '已退回预留米仔币' : '已退回預留米仔幣'
  if (record.type === 'DOOR_OPEN') {
    summary = en ? (charged ? `Charge confirmed: ${charged[1]} coin(s); no additional debit` : 'Charge confirmed; no additional debit')
      : cn ? (charged ? `已确认收费 ${charged[1]} 枚，无额外扣币` : '已确认收费，无额外扣币')
      : (charged ? `已確認收費 ${charged[1]} 枚，無額外扣幣` : '已確認收費，無額外扣幣')
    if (record.amount < 0) {
      words.DOOR_OPEN = en ? 'Door charge' : cn ? '开门扣币' : '開門扣幣'
      summary = en ? `${n} coin(s) debited; opening permitted` : cn ? `已扣 ${n} 枚，允许开门` : `已扣 ${n} 枚，允許開門`
    }
  }
  return {words, original, summary, operationId: id ? id[0] : null, isDoor}
}
